import React from 'react'
import PropTypes from 'prop-types'

import Bar from '_components/audience-insights/charts/bar/index.jsx'
import useRect from '../hooks/useRect'

function BarChartHOC({ data, valueType }) {
  const [Rect, rect] = useRect()

  return (
    <>
      <Rect />
      <foreignObject
        x="0"
        y="0"
        width={rect.width}
        height={rect.height}
        data-custom-render="ai-chart-bar"
        data-json={JSON.stringify(data)}
        data-export-options={JSON.stringify({ valueType })}
      >
        <Bar
          data={data}
          valueType={valueType}
          width={rect.width}
          height={rect.height}
          margin={{
            top: 50,
            right: 25,
            bottom: 50,
            left: 25,
          }}
        />
      </foreignObject>
    </>
  )
}

BarChartHOC.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      value: PropTypes.number.isRequired,
    })
  ).isRequired,
  valueType: PropTypes.oneOf(['percent', 'overIndex']),
}

BarChartHOC.defaultProps = {
  valueType: 'percent',
}

export default BarChartHOC
